export default {
  template: {
    label: 'テンプレート資産',
    describe: 'カスタムクリエイティブテンプレート',
    create: '空白作成',
    publicVideo: '公共ビデオテンプレート',
    publicVideoTitle: '新しいテンプレート-公共ビデオテンプレート',
    production: '新しいテンプレート',
    filter: {
      templateId: 'テンプレートID',
      state: '審査状態',
      unExamine: '未審査',
      examine: '審査済み',
      review: 'レンダリング中',
      reviewFailed: 'レンダリングに失敗しました',
      approved: '承認済み',
      refuse: '拒否',
      groundStatus: '販売状態',
      unGround: '未販売',
      ground: '販売済み',
      grounding: '販売中',
      groundFail: '販売失敗',
      grounded: '非公開です',
      replaceMaterial: '素材の置換',
      support: 'サポート',
      unSupport: 'サポートしない',
      templateType: 'テンプレートタイプ',
      commonTemplate: 'レイアウトテンプレート',
      contentTemplate: 'クリエイティブテンプレート',
      templateLabel: 'テンプレートタグ',
    },
    table: {
      label: 'テンプレート名およびID',
      size: '比率',
      chineseRules: 'テンプレートの中国語名は空白にできません',
      enRules: 'テンプレートの英語名は空白にできません',
      delete: 'テンプレートを削除',
      deleteLabel:
        '「{name} | {name_en}」テンプレートを削除してもよろしいですか？',
      unRename:
        '販売中または販売済みのテンプレートは、リネームをサポートしていません。',
      unDelete:
        '販売中または販売済みのテンプレートは、削除をサポートしていません。',
    },
    dialog: {
      common: 'マルチ比率',
      content: 'クリエイティブ',
    },
  },
}
